import { arrayContainsArray } from 'utils/array';

import { setNoRouteAccess } from 'apps/user/actions/user';
import { verifyUserLoginStatus } from 'apps/user/helpers';

export function verifyRequiredUserData(requiredFeaturesArr, fieldName) {
  return (nextState, replace, path, extras) => {
    const { store: { dispatch }, store } = extras;
    const { user } = store.getState();

    if (arrayContainsArray(user[fieldName], requiredFeaturesArr)) {
      return true;
    }
    dispatch(setNoRouteAccess());
    return false;
  };
}

export function verifyRequiredBetaFeatures(requiredFeaturesArr) {
  if (!Array.isArray(requiredFeaturesArr)) {
    // eslint-disable-next-line no-console
    console.error('[verifyRequiredBetaFeatures] Passed param is not an array');
  }
  return verifyRequiredUserData(requiredFeaturesArr, 'betaFeatures');
}

export function checkIfAnyRuleCollectionPairIsValid(user, requiredFeaturesArrWithUserLoginStatus) {
  const userBetaFeatures = (user && user.betaFeatures) || [];
  for (let i = 0; i < requiredFeaturesArrWithUserLoginStatus.length; i++) {
    const { auth, betaFeatures } = requiredFeaturesArrWithUserLoginStatus[i];

    if (verifyUserLoginStatus(user, auth) && arrayContainsArray(userBetaFeatures, betaFeatures)) {
      return true;
    }
  }
  return false;
}

function processRejectParameters(
  { dispatch, replace, redirectOnReject, setNoRouteAccessOnReject }
) {
  if (redirectOnReject) {
    if (typeof redirectOnReject === 'string') {
      replace(redirectOnReject);
    } else {
      // eslint-disable-next-line no-console
      console.error(
        '[verifyRequiredBetaFeaturesWithUserLoginStatusProcessRejectParameters]' +
        ' Incorrect "redirectOnReject" parameter type.'
      );
    }
  }
  if (setNoRouteAccessOnReject) {
    dispatch(setNoRouteAccess());
  }
}

/**
 * Function compares if any pair of user login status & beta features is valid.
 * Similar to @verifyRequiredBetaFeatures but validates user login status too.
 *
 * User login status: one of ANY, LOGGED_IN, LOGGED_OUT
 * Beta features: array of required to be enabled beta features
 *
 * @param {Object[]} requiredFeaturesArrWithUserLoginStatus
 * @param {string} requiredFeaturesArrWithUserLoginStatus[].auth - One of defined USER_LOGIN_STATUS
 * @param {array} requiredFeaturesArrWithUserLoginStatus[].betaFeatures - array of required beta features
 * @example [ {auth: USER_LOGIN_STATUS, betaFeatures: [BETA_FEATURES]}, {auth: USER_LOGIN_STATUS, betaFeatures: [BETA_FEATURES]}, ... ]
 *
 * @param {Object} opts - Reject options
 * @param {string|false} opts.redirectOnReject=false Redirect to provided string when all pairs are invalid
 * @param {boolean} opts.setNoRouteAccessOnReject=true - Set no route access when all pairs are invalid. Set to false
 *                                                        when opts.redirectOnReject to Raven page. True on redirect
 *                                                        out of Raven.
 */
export function verifyRequiredBetaFeaturesWithUserLoginStatus(
  requiredFeaturesArrWithUserLoginStatus,
  { redirectOnReject = false, setNoRouteAccessOnReject = true } = {}
) {
  return (nextState, replace, path, extras) => {
    const { store: { dispatch }, store } = extras;
    const { user } = store.getState();

    if (checkIfAnyRuleCollectionPairIsValid(user, requiredFeaturesArrWithUserLoginStatus)) {
      return true;
    }
    processRejectParameters(
      { dispatch, replace, redirectOnReject, setNoRouteAccessOnReject }
    );

    return false;
  };
}
